import React from 'react';

const IconButton = ({ Icon, onClick, className = '', size = 20 }) => (
    <button onClick={onClick} className={`${className} rounded bg-transparent`}>
        <Icon size={size} />
    </button>
);

export default IconButton;
